<template>
  <b-card
    no-body
    class="p-2 "
  >
    <b-tabs class="privilege-tab">
      <b-tab
        title="Point History"
        title-link-class="font-medium-5"
        lazy
        active
      >
        <b-card
          no-body
          class="m-0 privilege-table privilege-table-wrp"
        >
          <point-history-table />
        </b-card>
      </b-tab>
      <b-tab
        title="Privilege History"
        title-link-class="font-medium-5"
        lazy
      >
        <b-card
          no-body
          class="m-0 privilege-table privilege-table-wrp"
        >
          <privilege-history-table />
        </b-card>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BTabs, BTab, BCard } from 'bootstrap-vue'
import PointHistoryTable from './PointHistoryTable.vue'
import PrivilegeHistoryTable from './PrivilegeHistoryTable.vue'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    PointHistoryTable,
    PrivilegeHistoryTable,
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/data-management/privilege-table.css';
</style>
